"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineErlangFunction("maps", "keys", 1, (map) => {
    if (!Type.isMap(map)) {
      Interpreter.raiseBifError(["badmap", map], "maps", "keys", [map]);
    }

    return Type.list(Object.values(map.data).map(([key, _value]) => key));
  });

Interpreter.defineErlangFunction("sets", "to_list", 1, (set) => {
    if (!Type.isMap(set)) {
      Interpreter.raiseFunctionClauseError("sets", "to_list", 1, [set]);
    }

    return Erlang_Maps["keys/1"](set);
  });

Interpreter.defineElixirFunction("Enumerable.MapSet", "__impl__", 1, "public", [{params: (context) => [Type.atom("for")], guards: [], body: (context) => {
return Type.atom("Elixir.MapSet");
}}, {params: (context) => [Type.atom("protocol")], guards: [], body: (context) => {
return Type.atom("Elixir.Enumerable");
}}]);

Interpreter.defineElixirFunction("Enumerable.MapSet", "reduce", 3, "public", [{params: (context) => [Type.variablePattern("map_set_0"), Type.variablePattern("acc_1"), Type.variablePattern("fun_2")], guards: [], body: (context) => {
return Elixir_Enumerable_List["reduce/3"](Elixir_MapSet["to_list/1"](context.vars.map_set_0), context.vars.acc_1, context.vars.fun_2);
}}]);

Interpreter.defineElixirFunction("MapSet", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.MapSet")], [Type.atom("map"), Type.map([])]]);
}}]);

Interpreter.defineElixirFunction("MapSet", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
return Elixir_Enum["reduce/3"](context.vars.kv_0, Type.map([[Type.atom("__struct__"), Type.atom("Elixir.MapSet")], [Type.atom("map"), Type.map([])]]), Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.variablePattern("map_3")], guards: [], body: (context) => {
return Elixir_Map["merge/2"](context.vars.map_3, Type.map([[context.vars.key_1, context.vars.val_2]]));
}}], context, "-__struct__/1-fun-0-"));
}}]);

Interpreter.defineElixirFunction("MapSet", "to_list", 1, "public", [{params: (context) => [Type.map([[Type.atom("__struct__"), Type.atom("Elixir.MapSet")], [Type.atom("map"), Type.variablePattern("set_0")]])], guards: [], body: (context) => {
return Erlang_Sets["to_list/1"](context.vars.set_0);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));